'use client';

import { useState } from 'react';
import { FaqDrawer, FaqDrawerProps } from './FaqDrawer';
import cn from 'classnames';

type DrawerGridProps = {
  drawers: FaqDrawerProps[];
  hasDarkBackground?: boolean;
};

export const DrawerGrid = ({ drawers, hasDarkBackground }: DrawerGridProps) => {
  const [activeDrawerIndex, setActiveDrawerIndex] = useState<number | null>(null);

  const handleClick = (index: number) => {
    if (index === activeDrawerIndex) return setActiveDrawerIndex(null);

    setActiveDrawerIndex(index);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-x-gutter-mobile md:gap-x-gutter-desktop">
      <div className="md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
        <div className="-mx-2 md:-mx-3">
          {drawers.map((drawer, index) => (
            <div
              key={drawer.question}
              className={cn(`${index > 0 ? 'border-t-2 border-solid' : 'border-none'}`, {
                'border-violet-700 px-[16px] mx-[16px]': hasDarkBackground,
                'border-gray-100': !hasDarkBackground,
              })}
            >
              <FaqDrawer
                {...drawer}
                onClick={() => handleClick(index)}
                isOpen={index === activeDrawerIndex}
                hasDarkBackground={hasDarkBackground}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
